import { useState } from "react";
import { recordRoadshowEvent } from "../lib/analytics";

type Choice = { id: string; label: string };

type ChoiceGroupProps = {
  sectionId: string;
  questionId: string;
  title: string;
  choices: readonly Choice[];
};

export function ChoiceGroup({ sectionId, questionId, title, choices }: ChoiceGroupProps) {
  const [selected, setSelected] = useState<string | null>(null);

  async function choose(choice: Choice) {
    setSelected(choice.id);
    await recordRoadshowEvent({
      sectionId,
      questionId,
      choice: choice.id,
      eventType: "choice"
    });
  }

  return (
    <div className="choice-panel">
      <h3>{title}</h3>
      <div className="choice-grid">
        {choices.map((choice) => (
          <button
            key={choice.id}
            className={selected === choice.id ? "choice-card is-selected" : "choice-card"}
            type="button"
            onClick={() => choose(choice)}
          >
            {choice.label}
          </button>
        ))}
      </div>
      {selected ? <p className="choice-note">已记录：谢谢，这会进入会后匿名反馈统计。</p> : null}
    </div>
  );
}
